<template>
  <div class="comment-item">
    <div class="head">
      <van-image style="pointer-events:none;"
        width="48"
        height="48"
        radius="50%"
        :src="item.avatar"
      ></van-image>
    </div>
    <div class="right">
      <div class="top">
        <div class="info">
          <div class="name">
            {{ item.nickname }}
          </div>
          <!-- <div> {{ item.title }}</div> -->
        </div>
        <div class="like">
          <van-image
            width="16"
            height="16"
            :src="require('@/assets/lick-icon.png')"
          ></van-image>
          <span>{{item.likeCount ? item.likeCount : '0'}}</span>
          <wx-open-launch-app class="openApp" appid="wxa496fd5f0644bb66" :extinfo="extinfo" @error="openAppErr">
            <template>
                <script type="text/wxtag-template">
                  <div style="position: absolute; top: 0; left: 0;width: 100%; height:100%;opacity: 0;">
                  此div必须有内容才可点击，但不能在页面上展示，固采用透明度隐藏此div
                  </div>
              </script>
            </template>
          </wx-open-launch-app>
        </div>
      </div>
      <div class="conten">
        {{ item.content }}
      </div>
      <div class="add">
        {{ item.createTime ? item.createTime : '' }}
        <span v-if="item.area">{{ item.area }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {
        }
      }
    }
  },
  data () {
    return {
      extinfo: 'yslt://?name=galleryPerson&'
    }
  },
  async created () {
    this.extinfo = this.extinfo + `userId=${this.item.topicId}`
  },
  methods: {
    openAppErr () {
      window.open('https://a.app.qq.com/o/simple.jsp?pkgname=yslt.art.app', '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.comment-item {
  display: flex;
  line-height: 1;
  margin: 10px 0 20px 0;

  .head {
    margin-right: 10px;
  }

  .right {
    flex: 1;

    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 6px;

      .info {

        .name {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #333333;
        }

        > div {
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #b8b8b8;
          width: 200px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }

      .like {
        position: relative;
        display: flex;
        align-items: flex-end;

        > span {
          margin-left: 5px;
          color: #666;
          font-size: 12px;
        }
      }
    }

    .conten {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
      margin: 15px 0;
    }

    .add {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #b8b8b8;

      > text {
        margin: 0 5px;
        color: #b8b8b8;
      }
      >span {
        margin-left: 2px;
      }
    }
  }
}
.openApp {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.active {
  color: #8e2912 !important;
}
</style>
